import { Alert } from "@idg-web-platform/pulse";
import css from "./approvalBox.module.css";

/**
 * Shown while a membership sits in ApprovalRequired: Convercus reports an existing CLUB membership
 * for the email address, and we cannot send the approval email yet because the address information
 * is still missing. Deliberately not the ApprovalBox — no email has been sent at this point, so
 * offering "request it again" would only produce an error.
 */
export function ApprovalRequiredBox() {
  return (
    <Alert
      type="warning"
      headline="Bestätige deine CLUB-Mitgliedschaft"
      showCloseButton={false}
      description="Für diese E-Mail-Adresse besteht bereits eine CLUB-Mitgliedschaft. Sobald du deine Registrierung mit deiner Adresse abgeschlossen hast, schicken wir dir eine E-Mail, mit der du deinen CLUB mit deinem Online-Konto verknüpfen kannst."
    >
      <div className={css.alertContent}>
        Registrierung schon abgeschlossen? Dann melde dich bitte bei unserem{" "}
        <a href="/c/account/contact?issue=club">Kundenservice</a>.
      </div>
    </Alert>
  );
}
